export enum EEtapaConfiguracaoInicial {
  Empresa = 1,
  Equipe = 2,
  Produtos = 3,
  Financeiro = 4,
  Vendas = 5,
}
